var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApiTradingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.016,
    height: 110.715,
    viewBox: "0 0 87.016 110.715",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "API_Trading-icon",
    transform: "translate(-231.556 -197.785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M251.132,338.006a18.418,18.418,0,0,1-7.106,1.6c-3.783,0-11.479-7.649-11.479-7.649s-.279-.824.323-3.9,6.253-31.351,6.253-31.351.667-6.579,4.488-10.618,11.321-5.478,11.321-5.478,16.585-7.066,25.889-4.884c9.293,3.611,19.444,7.28,22.833,10.126s11.72,25.676,14.606,37.4c0,0-6.357,13.218-12.288,16.93s-20.225,2.5-20.225,2.5Z",
    transform: "translate(-0.185 -35.722)",
    fill: "#3fb9ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M249,322.479l-2.4-31.159a10.29,10.29,0,0,0-6.281,7.269c-1.241,5.574-8.746,39.878-7.817,40.83s5.822,5.055,5.822,5.055S243.6,348.888,249,346.25,249,322.479,249,322.479Z",
    transform: "translate(-0.159 -43.169)",
    fill: "#3fb9ea",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M272.666,288.9c-.279.931-1.476,1.23-2.471,1.241a11.93,11.93,0,0,1-7.8-2.782c-.394-.337-7.429,3.916-8.238,4.338-1.279.674-2.531,1.412-3.826,2.038-1.214.583-2.361.872-3.154,2.049A10.448,10.448,0,0,0,246,298.563c-1.705,5.467-3.5,10.918-5.056,16.422-1.345,4.766-3.154,10.04-3.078,15.042a7.766,7.766,0,0,0,.077,1.07c1.093,6.392,13.021,9.045,13.021,9.045s-4.22,2.53-7.106,1.6-9.632-4.7-11.758-8.232l5.854-29.955s-.071-14.443,10.566-18.722,14.814-4.937,14.814-4.937Z",
    transform: "translate(-0.012 -37.858)",
    opacity: 0.044
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M366.632,342.032s4.646-5.023,6.15-10.618c0,0-7.106-22.969-8.954-27.281s-4.838-9.206-6.931-11.3l-3.4,47.276-.716,9.949a16.768,16.768,0,0,0,6.478-1.07C361.909,347.76,366.632,342.032,366.632,342.032Z",
    transform: "translate(-54.725 -43.871)",
    fill: "#3fb9ea",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M310.009,341.369l4.116-57.236s-19.93-9.094-25.145-9.96-30.54,8.9-30.54,8.9l3.684,54.893",
    transform: "translate(-11.954 -35.169)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.029
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M282.639,221.082l-2.044,9.6s-2.624-1.813-3.181.235,1.148,4.868,4.444,5.023a16.375,16.375,0,0,0,3.826,7.3,54.024,54.024,0,0,0,4.373,4.087s1.153,7.291,4.92,7.569,4.5-3.038,5.259-7.649a60.129,60.129,0,0,0,4.2-8.505s3.99-2.723,1.328-6.7c0,0,1.317-9.505-.973-11.11S286.635,220.151,282.639,221.082Z",
    transform: "translate(-20.509 -10.012)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M300.167,277.886s-1.263,6.226-2.05,6.382-3.9-2.755-6.625-6.382-2.3-3.632-2.3-3.632,1.263-4.761,2.3-5.456,4.783-.61,4.783-.61l8.2-.3a7.8,7.8,0,0,1,4.422.685c1.689,1.064,2.509,5.686,2.509,5.686s-4.92,8.874-8.932,10.014a57.543,57.543,0,0,1-2.307-6.381Z",
    transform: "translate(-25.885 -32.238)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    y1: 14.935,
    x2: 1.088,
    transform: "translate(247.404 277.464)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1.029
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M297.27,225.713s-4.346,4.279-9.91,1.738c0,0-5.018,13.3,6.489,22a19.41,19.41,0,0,1-11.977-13.057s-3.28.5-4.444-4.279c0,0-.946-1.845,3.367-1.856L280.609,221l11.08,2.177,7.953-1.139S301.386,226.05,297.27,225.713Z",
    transform: "translate(-20.522 -10.464)",
    fill: "#3fb9ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M306.039,224.266a23.7,23.7,0,0,1-8.773,1.428s-4.346,4.279-9.91,1.738c0,0-4.056,14.239,6.013,21.755,0,0-9.134-3.1-11.507-12.838a5.647,5.647,0,0,1-4.444-4.279s-.946-1.845,3.367-1.856l-.186-9.254,11.08,2.177L299.632,222Z",
    transform: "translate(-20.518 -10.446)",
    fill: "#c9d6dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M306.68,255.2a11.809,11.809,0,0,0,1.132.792c.257.161.645.289.826.054a.585.585,0,0,0,.093-.321c.164-2.626-.465-5.28-.082-7.885",
    transform: "translate(-33.824 -22.947)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.029
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M313.51,243.858s1.334-2.878,4.772-.294",
    transform: "translate(-36.921 -20.458)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.059
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M300.93,244.842s-2.514-3.06-5.63.1",
    transform: "translate(-28.665 -20.934)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.059
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M299.39,269.75s1.339,7.847,6.062,8.088c3.826.193,4.581-6.3,4.728-8.618",
    transform: "translate(-30.519 -32.891)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.029
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M281.236,240.212s-2.083-2.434-3.493-1.246.705,6.419,4.111,5.627",
    transform: "translate(-20.504 -18.668)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.029
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M301,263.42a7.384,7.384,0,0,0,4,2.418",
    transform: "translate(-31.249 -30.193)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.029
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 0.541,
    cy: 1.123,
    rx: 0.541,
    ry: 1.123,
    transform: "translate(268.98 226.428)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M316.713,251.829c0,.62-.246,1.123-.547,1.123s-.547-.5-.547-1.123.241-1.129.547-1.129S316.713,251.208,316.713,251.829Z",
    transform: "translate(-37.877 -24.277)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M300.353,277.55s-1.312,6.991-2.187,7.146-7.6-5.815-8.926-10.014c0,0,1.421-5.488,2.733-5.686.618-.1,1.328-.187,1.891-.257",
    transform: "translate(-25.918 -32.668)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.029
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M309.57,277s1.268,6.991,2.154,7.146,7.609-5.815,8.932-10.014c0,0-1.607-5.451-2.826-5.911a15.3,15.3,0,0,0-2.394-.663",
    transform: "translate(-35.135 -32.119)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.029
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M282.58,228.656c.864,1.466,1.935-3.7,1.481-5.349a14.99,14.99,0,0,1-.957-3.21,8.928,8.928,0,0,1,1.017-3.595,3.9,3.9,0,0,0,0-3.616,16.943,16.943,0,0,0,8.429,2.958,5.407,5.407,0,0,0,2.307-.182,2.233,2.233,0,0,0,1.5-1.6,33.014,33.014,0,0,0,8.489.337c2.378-.316,6.073-.9,7.292-3.279,1.787-3.466-2.815-7.066-5.532-8.281-6.56-2.937-15.426-3.434-21.351,1.177a21.608,21.608,0,0,1-1.908,1.444c-1.306.8-4.28,1.423-5.324,2.541-1.4,1.5.355,13.111.355,13.111s2.285-1.038,3.225,2.423C282.257,225.864,281.705,227.18,282.58,228.656Z",
    transform: "translate(-20.586 -0.971)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M326.056,221.894a2.547,2.547,0,0,0-.077.439,11.777,11.777,0,0,0,.476,3.9c.148.567.361,1.118.454,1.7.219,1.375.219,2.7,1.257,3.819,0,0,1.99-6.809,1.186-11.677-.093-.535-.273-1.979-1.153-1.717-.645.193-1.093,1.273-1.377,1.8a8.919,8.919,0,0,0-.765,1.744Z",
    transform: "translate(-42.568 -9.219)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M275.89,206.256a6.881,6.881,0,0,1,6.106-.8,21.087,21.087,0,0,1,6.467-6.954",
    transform: "translate(-19.865 0)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.029
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M291.53,208.466s10.714,7.457,17.2,5.611,4.674-7.307,4.674-7.307",
    transform: "translate(-26.956 -3.846)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.029,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M293.42,205.414s13.453,6.05,15.716-2.514",
    transform: "translate(-27.813 -2.046)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.029,
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M299.39,269.75s2.558,4.862,4.564,4.782,5.685-5.312,5.685-5.312a7.956,7.956,0,0,1-5,2.76C302.659,272.151,299.39,269.75,299.39,269.75Z",
    transform: "translate(-30.519 -32.891)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M310.76,327.412l.415-.187a1.1,1.1,0,0,0,.651-1.214l-.082-.492a1.112,1.112,0,0,0-1.033-.92l-.5-.043a1.121,1.121,0,0,1-.935-.626c-.137-.278-.279-.535-.437-.813a1.076,1.076,0,0,1,0-1.1l.257-.428a1.121,1.121,0,0,0-.18-1.364l-.361-.348a1.111,1.111,0,0,0-1.394-.166l-.443.257a1.142,1.142,0,0,1-1.126,0,9.208,9.208,0,0,0-2.29-.915,1.114,1.114,0,0,1-.809-.8l-.131-.535a1.089,1.089,0,0,0-1.126-.845h-.5a1.09,1.09,0,0,0-1.126.84l-.142.535a1.081,1.081,0,0,1-.793.792c-.284.08-.547.16-.831.262a1.151,1.151,0,0,1-1.121-.2l-.454-.38a1.112,1.112,0,0,0-1.383-.08l-.4.267a1.058,1.058,0,0,0-.421,1.327l.2.535a1.088,1.088,0,0,1-.175,1.1,7.577,7.577,0,0,0-.508.658,1.13,1.13,0,0,1-1.044.471l-.547-.048a1.1,1.1,0,0,0-1.186.733l-.18.481a1.089,1.089,0,0,0,.41,1.289l.547.358a1.109,1.109,0,0,1,.47,1.011,6.446,6.446,0,0,0-.044.861h0a1.135,1.135,0,0,1-.547.936l-.547.289a1.093,1.093,0,0,0-.547,1.268l.131.481a1.118,1.118,0,0,0,1.126.824h.547a1.142,1.142,0,0,1,.984.535,7.121,7.121,0,0,0,.487.765,1.082,1.082,0,0,1,.087,1.1l-.23.471a1.086,1.086,0,0,0,.3,1.343l.388.321a1.145,1.145,0,0,0,1.4.048l.4-.278a1.114,1.114,0,0,1,1.093-.1c.29.134.579.251.88.364a1.1,1.1,0,0,1,.716.845l.082.481a1.123,1.123,0,0,0,1.039.92l.514.043a1.121,1.121,0,0,0,1.17-.744l.159-.428a1.125,1.125,0,0,1,.875-.722,9.575,9.575,0,0,0,.946-.2,1.148,1.148,0,0,1,1.093.289l.333.332a1.144,1.144,0,0,0,1.378.182l.448-.246a1.093,1.093,0,0,0,.547-1.273l-.126-.428a1.091,1.091,0,0,1,.284-1.1,9.164,9.164,0,0,0,.667-.711,1.14,1.14,0,0,1,1.093-.374l.454.086a1.132,1.132,0,0,0,1.241-.631l.213-.449a1.081,1.081,0,0,0-.317-1.343l-.339-.273a1.059,1.059,0,0,1-.415-1.022,8.671,8.671,0,0,0,.1-.99,1.1,1.1,0,0,1,.645-.877Zm-6.773.284a2.974,2.974,0,1,1-2.974-2.9h0a2.932,2.932,0,0,1,2.968,2.889Z",
    transform: "translate(-26.408 -55.051)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M256.349,370.28a11.306,11.306,0,0,1-1.46,1.321,11.949,11.949,0,0,0-3.11,4.857,3.884,3.884,0,0,0,0,2.632c.661,1.6,2.76,3.21,4.439,2.182",
    transform: "translate(-8.83 -79.892)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.029
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M254.187,364.965a5.09,5.09,0,0,0-4.269,1.824c-1.093,1.161-1.853,2.594-2.848,3.841",
    transform: "translate(-6.799 -77.401)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.029
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M247.262,346.627a11.048,11.048,0,0,1-6.335-.663,17.927,17.927,0,0,1-3.509-2.418l-4.154-3.359c-.667-.535-1.4-1.311-1.132-2.113,0,0,6.942-35.8,8.03-39.675,1.263-4.467,6.346-7.489,6.346-7.489",
    transform: "translate(0 -42.979)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.029
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M355.15,371a11.532,11.532,0,0,1,3.941,5.151A27.931,27.931,0,0,1,360.332,382c-1.093.588-3.28,2.14-5.182,2.14",
    transform: "translate(-55.799 -80.227)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.029
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M355.58,365.346c1.684-.439,3.351.685,4.625,1.851s2.58,2.519,4.313,2.7",
    transform: "translate(-55.994 -77.552)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.029
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M356.17,350.269a15.042,15.042,0,0,0,8.593-4.317,43.5,43.5,0,0,0,5.975-7.617,22.962,22.962,0,0,0,3.58-6.922s-5.756-18.62-8.954-27.281c-3.334-9-6.931-11.3-6.931-11.3",
    transform: "translate(-56.261 -43.871)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.029
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M355.58,364.435c2.968-2.439,7.522-.465,10.714,1.171",
    transform: "translate(-55.994 -76.642)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.029
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 51.826,
    height: 29.148,
    transform: "translate(247.519 277.828)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 52.324,
    height: 1.525,
    transform: "translate(247.262 306.975)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M259.86,375.948,311.949,346.8l.235,29.148Z",
    transform: "translate(-12.598 -68.972)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M259.86,375.948,311.949,346.8l.235,29.148Z",
    transform: "translate(-12.598 -68.972)",
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16025",
    "data-name": "Path 16025",
    d: "M4.344.022A4.486,4.486,0,0,1,8.761,4.439,4.257,4.257,0,0,1,4.439,8.761,4.486,4.486,0,0,1,.022,4.344,4.257,4.257,0,0,1,4.344.022Z",
    transform: "translate(267.922 291.925) rotate(-45)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 51.826,
    height: 29.148,
    transform: "translate(247.519 277.828)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.029
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M284.06,236.06s1.137,10.163,2.58,12,6.079,8.473,11.129,8.371,8.347-6.456,9.172-9.179a46.269,46.269,0,0,0,1.853-10.586",
    transform: "translate(-23.569 -17.469)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.029
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M326.88,249.177s3.744-1.894,1.328-6.7",
    transform: "translate(-42.982 -20.454)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.029
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiTradingIcon);
export default __webpack_public_path__ + "static/media/API_Trading-icon.6f9d291e356d5aea9afee64ad64ca32b.svg";
export { ForwardRef as ReactComponent };